import { parseCookies } from "nookies";

export const getToken = () => {
  if (typeof window === "undefined") {
    return null;
  }
  const { atab_ua } = parseCookies();
  return atab_ua;
};
